import script from "./laboratory.vue?vue&type=script&setup=true&lang=ts"
export * from "./laboratory.vue?vue&type=script&setup=true&lang=ts"

import "./laboratory.vue?vue&type=style&index=0&id=178482e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178482e3"]])

export default __exports__